export { App, AppProps } from './App';
export { Chat, ChatProps } from './Chat';
export * from 'botframework-directlinejs';
export { queryParams } from './Attachment';
export { SpeechOptions } from './SpeechOptions';
export { Speech } from './SpeechModule';



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/BotChat.ts